// Centralized Price Configuration
// Edit this file to change prices across the entire application
// All prices are in rupees (₹)
//
// COURSE IDENTIFICATION:
// - Payment URLs now include course names: /Rezorpay/{price}/{course}
// - Use getPaymentLink("PYTHON") for course-specific payment links
// - Course info is available in payment success callbacks

export const COURSE_PRICES = {
  // Main Professional Courses
  PYTHON: 5999,                    // Python Programming - Professional (Beginner → Advanced)
  PYTHON_VIDEO: 6999,              // Python Recorded Video Course
  GRAPHIC_DESIGNING: 2999,           // Graphic Designing - Photoshop, CorelDRAW, etc.
  WEB_DESIGNING_VIDEO: 4999,        // Web Design Recorded Video Course
  DCA: 5999,                      // DCA - Basic Computer Course
  HN: 5999,                       // Hardware & Networking
  CCC: 19999,                      // CCC / O-Level Preparation

  // Advanced Computer Courses
  ADCA: 10999,                     // Advanced Diploma in Computer Applications
  DTP: 2999,                      // Desktop Publishing (Photoshop, CorelDRAW, PageMaker)
  WEB_DESIGNING: 5999,            // Web Designing (HTML, CSS, JavaScript)
  PROGRAMMING: 7999,              // Programming (C, C++, Java, Python)
  TALLY: 2999,                    // Tally + GST

  // Specialized Courses
  MS_OFFICE: 2999,                // MS Office Advanced
  TYPING: 1499,                   // Typing Training
  TALLY_VIDEO: 3999,              // Tally Recorded Video Course

  // Legacy/Other (keeping for compatibility)
  WEB_DEVELOPMENT: 5999,
  VIEW_DETAIL: 3999,

  // Default fallback price
  DEFAULT: 3999
};

// Helper function to get price by course name
export const getCoursePrice = (courseName) => {
  const upperCaseName = courseName.toUpperCase().replace(/\s+/g, '_');
  return COURSE_PRICES[upperCaseName] || COURSE_PRICES.DEFAULT;
};

// Helper function to format price with currency symbol
export const formatPrice = (price) => {
  return `₹${price.toLocaleString('en-IN')}`;
};

// Helper function to get payment link with amount and course
export const getPaymentLink = (courseName) => {
  const price = getCoursePrice(courseName);
  return `/Rezorpay/${price}/${courseName}`;
};

// Helper function to get course name from price (for reverse lookup)
export const getCourseFromPrice = (price) => {
  for (const [courseName, coursePrice] of Object.entries(COURSE_PRICES)) {
    if (coursePrice === price) {
      return courseName;
    }
  }
  return 'UNKNOWN_COURSE';
};